import { Component, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ImageMasterService } from "src/app/Common/ImageMasterService/image-master.service";
import {
  DocumentVerificationSessionDeleteRequestDTO,
  DocumentVerificationSessionDTO,
  DocumentVerificationSessionReadByIdRequestDTO,
} from "src/app/Shared Utilities/documentVerificationSession/documentVerificationSession.interface";
import { DocumentVerificationSessionService } from "src/app/Shared Utilities/documentVerificationSession/documentVerificationSession.service";
import {
  SocietyDocMasterCreateBulkObjectDTO,
  SocietyDocMasterCreateBulkRequestDTO,
  SocietyDocMasterReadByMasterIdRequestDTO,
} from "src/app/housing-society/BackOffice/society-doc-master/society-doc-master.interface";
import { SocietyDocMasterService } from "src/app/housing-society/BackOffice/society-doc-master/society-doc-master.service";
import {
  SocietyDTO,
  SocietyReadByIdRequestDTO,
} from "src/app/housing-society/Interface & Service/society/society.interface";
import { SocietyService } from "src/app/housing-society/Interface & Service/society/society.service";

@Component({
  selector: "app-society-doc-verification",
  templateUrl: "./society-doc-verification.component.html",
  styleUrls: ["./society-doc-verification.component.css"],
})
export class SocietyDocVerificationComponent {
  constructor(private route: ActivatedRoute, private router: Router) {}

  private imgUploadService = inject(ImageMasterService);
  private documentVerificationSessionServices = inject(
    DocumentVerificationSessionService
  );
  private societyDocMasterService = inject(SocietyDocMasterService);
  private societyService = inject(SocietyService);

  // Timer
  timerText: string = "00:00:00";
  totalSeconds: number = 0;

  isAllRequiredDocumentsUploaded: boolean = false;
  sessionInfo: DocumentVerificationSessionDTO | null = null;

  isDataLoading: boolean = true;

  isUploading: boolean = false;

  societyInfo: SocietyDTO | null = null;

  // Documents
  // documents = [
  //   {
  //     name: "Society-Registration-Certificate",
  //     displayName: "Society Registration Certificate",
  //     category: "Society Onboarding Verification",
  //     subtext:
  //       "Verify registration number, society name, and issuing authority",
  //     required: true,
  //     uploaded: false,
  //     uploading: false,
  //     fileName: "",
  //     fileUrl: "",
  //     isAlreadyUploaded: false,
  //     uploadedTime: "",
  //   },

  //   {
  //     name: "PAN",
  //     displayName: "PAN Card (Society)",
  //     category: "Society Onboarding Verification",
  //     subtext: "Verify PAN matches the registered society name",
  //     required: true,
  //     uploaded: false,
  //     uploading: false,
  //     fileName: "",
  //     fileUrl: "",
  //     isAlreadyUploaded: false,
  //     uploadedTime: "",
  //   },

  //   {
  //     name: "Society-Bye-Laws",
  //     displayName: "Approved Society Bye-Laws",
  //     category: "Society Onboarding Verification",
  //     subtext: "Verify governance structure, rules, and committee roles",
  //     required: true,
  //     uploaded: false,
  //     uploading: false,
  //     fileName: "",
  //     fileUrl: "",
  //     isAlreadyUploaded: false,
  //     uploadedTime: "",
  //   },

  //   {
  //     name: "Society-Address-Proof",
  //     displayName: "Society Address Proof",
  //     category: "Society Onboarding Verification",
  //     subtext:
  //       "Utility bill or tax receipt matching registered society address",
  //     required: true,
  //     uploaded: false,
  //     uploading: false,
  //     fileName: "",
  //     fileUrl: "",
  //     isAlreadyUploaded: false,
  //     uploadedTime: "",
  //   },

  //   {
  //     name: "Managing-Committee-List",
  //     displayName: "Managing Committee List",
  //     category: "Society Onboarding Verification",
  //     subtext: "Verify authorized office bearers and their designations",
  //     required: true,
  //     uploaded: false,
  //     uploading: false,
  //     fileName: "",
  //     fileUrl: "",
  //     isAlreadyUploaded: false,
  //     uploadedTime: "",
  //   },

  //   {
  //     name: "Society-Bank-Account-Proof",
  //     displayName: "Society Bank Account Proof",
  //     category: "Society Onboarding Verification",
  //     subtext: "Verify official society bank account details",
  //     required: false,
  //     uploaded: false,
  //     uploading: false,
  //     fileName: "",
  //     fileUrl: "",
  //     isAlreadyUploaded: false,
  //     uploadedTime: "",
  //   },

  //   {
  //     name: "Occupancy-Certificate",
  //     displayName: "Occupancy / Completion Certificate",
  //     category: "Society Onboarding Verification",
  //     subtext: "Confirm building approval for residential occupancy",
  //     required: false,
  //     uploaded: false,
  //     uploading: false,
  //     fileName: "",
  //     fileUrl: "",
  //     isAlreadyUploaded: false,
  //     uploadedTime: "",
  //   },

  //   {
  //     name: "Conveyance-Deed",
  //     displayName: "Conveyance Deed",
  //     category: "Society Onboarding Verification",
  //     subtext:
  //       "Verify legal transfer of land and building ownership to society",
  //     required: false,
  //     uploaded: false,
  //     uploading: false,
  //     fileName: "",
  //     fileUrl: "",
  //     isAlreadyUploaded: false,
  //     uploadedTime: "",
  //   },

  //   {
  //     name: "Builder-NOC",
  //     displayName: "Builder No Objection Certificate (NOC)",
  //     category: "Society Onboarding Verification",
  //     subtext: "Confirm builder has no objection to society formation",
  //     required: false,
  //     uploaded: false,
  //     uploading: false,
  //     fileName: "",
  //     fileUrl: "",
  //     isAlreadyUploaded: false,
  //     uploadedTime: "",
  //   },
  // ];

  // Documents
documents = [
  {
    name: "Society-Registration-Certificate",
    displayName: "Society Registration Certificate",
    category: "Society Onboarding Verification",
    subtext: "Verify registration number, society name, and issuing authority",
    uploaded: false,
    uploading: false,
    fileName: "",
    fileUrl: "",
    isAlreadyUploaded: false,
    uploadedTime: "",
  },
  {
    name: "PAN",
    displayName: "PAN Card (Society)",
    category: "Society Onboarding Verification",
    subtext: "Verify PAN matches the registered society name",
    uploaded: false,
    uploading: false,
    fileName: "",
    fileUrl: "",
    isAlreadyUploaded: false,
    uploadedTime: "",
  },
  {
    name: "Society-Bye-Laws",
    displayName: "Approved Society Bye-Laws",
    category: "Society Onboarding Verification",
    subtext: "Verify governance structure, rules, and committee roles",
    uploaded: false,
    uploading: false,
    fileName: "",
    fileUrl: "",
    isAlreadyUploaded: false,
    uploadedTime: "",
  },
  {
    name: "Society-Address-Proof",
    displayName: "Society Address Proof",
    category: "Society Onboarding Verification",
    subtext: "Utility bill or tax receipt matching registered society address",
    uploaded: false,
    uploading: false,
    fileName: "",
    fileUrl: "",
    isAlreadyUploaded: false,
    uploadedTime: "",
  },
  {
    name: "Managing-Committee-List",
    displayName: "Managing Committee List",
    category: "Society Onboarding Verification",
    subtext: "Verify authorized office bearers and their designations",
    uploaded: false,
    uploading: false,
    fileName: "",
    fileUrl: "",
    isAlreadyUploaded: false,
    uploadedTime: "",
  },
  {
    name: "Society-Bank-Account-Proof",
    displayName: "Society Bank Account Proof",
    category: "Society Onboarding Verification",
    subtext: "Verify official society bank account details",
    uploaded: false,
    uploading: false,
    fileName: "",
    fileUrl: "",
    isAlreadyUploaded: false,
    uploadedTime: "",
  },
  {
    name: "Occupancy-Certificate",
    displayName: "Occupancy / Completion Certificate",
    category: "Society Onboarding Verification",
    subtext: "Confirm building approval for residential occupancy",
    uploaded: false,
    uploading: false,
    fileName: "",
    fileUrl: "",
    isAlreadyUploaded: false,
    uploadedTime: "",
  },
  {
    name: "Conveyance-Deed",
    displayName: "Conveyance Deed",
    category: "Society Onboarding Verification",
    subtext: "Verify legal transfer of land and building ownership to society",
    uploaded: false,
    uploading: false,
    fileName: "",
    fileUrl: "",
    isAlreadyUploaded: false,
    uploadedTime: "",
  },
  {
    name: "Builder-NOC",
    displayName: "Builder No Objection Certificate (NOC)",
    category: "Society Onboarding Verification",
    subtext: "Confirm builder has no objection to society formation",
    uploaded: false,
    uploading: false,
    fileName: "",
    fileUrl: "",
    isAlreadyUploaded: false,
    uploadedTime: "",
  },
];

  otherDocuments = [];

  uploadedCount = 0;
  totalDocuments = 0;
  uploadPercent = 0;

  verificationDocuments: { [key: string]: string } = {};

  ngOnInit(): void {
    this.route.paramMap.subscribe((param) => {
      const sessionId = param.get("sessionId");
      const societyId = param.get("societyId");

      if (sessionId && /^[0-9]+$/.test(sessionId)) {
        this.verifySessionAndGetData(Number(sessionId));
        this.getSocietyInfoBySocietyId(Number(societyId));
        this.getDocumentsByMasterId(
          "Society Onboarding Verification",
          Number(societyId)
        );
      } else {
        this.isDataLoading = false;
      }
    });
  }

  verifySessionAndGetData(sessionId: number) {
    const payload: DocumentVerificationSessionReadByIdRequestDTO = {
      sessionId: sessionId,
    };
    this.documentVerificationSessionServices
      .DocumentVerificationSession_ExternalReadById(payload)
      .subscribe({
        next: (res) => {
          if (res && res.masterType === "Society") {
            this.sessionInfo = res;
            this.calculateRemainingTime(res.expiresOn.toString());
            this.startTimer();
          }
          this.isDataLoading = false;
        },
        error: (err) => {
          console.log(err);
          this.isDataLoading = false;
        },
      });
  }

  getSocietyInfoBySocietyId(societyId: number) {
    const payload: SocietyReadByIdRequestDTO = {
      societyId,
    };

    this.societyService.Society_ExternalReadById(payload).subscribe({
      next: (res) => {
        this.societyInfo = res;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  calculateRemainingTime(expiresOn: string) {
    const expiry = new Date(expiresOn).getTime();
    const now = new Date().getTime();

    let diff = Math.floor((expiry - now) / 1000);

    if (diff <= 0) {
      return { timerText: "00:00:00", totalSeconds: 0 };
    }

    const hours = Math.floor(diff / 3600);
    const minutes = Math.floor((diff % 3600) / 60);
    const seconds = diff % 60;

    const timerText =
      (hours < 10 ? "0" + hours : hours) +
      ":" +
      (minutes < 10 ? "0" + minutes : minutes) +
      ":" +
      (seconds < 10 ? "0" + seconds : seconds);

    this.timerText = timerText;
    this.totalSeconds = diff;

    return true;
  }

  // Timer countdown
  startTimer() {
    setInterval(() => {
      if (this.totalSeconds <= 0) {
        this.verifySessionAndGetData(this.sessionInfo?.sessionId || 0);
        return;
      }

      const hours = Math.floor(this.totalSeconds / 3600);
      const minutes = Math.floor((this.totalSeconds % 3600) / 60);
      const seconds = this.totalSeconds % 60;

      this.timerText = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(
        seconds
      )}`;
      this.totalSeconds--;
    }, 1000);
  }

  pad(num: number): string {
    return num.toString().padStart(2, "0");
  }

  // isAllDocumentUploaded() {
  //   let isValid = true;

  //   for (const d of this.documents) {
  //     if (d.required && !d.isAlreadyUploaded && !d.fileUrl) {
  //       isValid = false;
  //       break;
  //     }
  //   }

  //   this.isAllRequiredDocumentsUploaded = isValid;
  // }

  isAllDocumentUploaded() {
  const hasNewUploadedDocument = this.documents.some(
    (d) => !d.isAlreadyUploaded && d.fileUrl !== ""
  );

  this.isAllRequiredDocumentsUploaded = hasNewUploadedDocument;
}

  // Upload document with loader
  uploadDocument(index: number, event: any) {
    const file = event.target.files[0];
    if (!file) return;

    this.uploadDocumentAndStoreURL(file, index);
  }

  // removeDocument(index: number) {
  //   this.documents[index].uploaded = false;
  //   this.documents[index].fileUrl = "";
  //   this.documents[index].uploadedTime = "";
  //   this.documents[index].uploading = false;
  //   this.updateProgress();
  //   this.isAllDocumentUploaded();

  //   console.log("document list", this.documents);
  // }

  removeDocument(index: number) {
  this.documents[index].uploaded = false;
  this.documents[index].fileUrl = "";
  this.documents[index].fileName = "";
  this.documents[index].uploadedTime = "";
  this.documents[index].uploading = false;

  this.updateProgress();
  this.isAllDocumentUploaded();
}

  // updateProgress() {
  //   this.uploadedCount = this.documents.filter((d) => d.uploaded).length;
  //   this.uploadPercent = (this.uploadedCount / this.totalDocuments) * 100;
  // }

  updateProgress() {
  this.uploadedCount = this.documents.filter(
    (d) => !d.isAlreadyUploaded && d.uploaded
  ).length;

  if (!this.totalDocuments || this.totalDocuments <= 0) {
    this.uploadPercent = 0;
    return;
  }

  this.uploadPercent = (this.uploadedCount / this.totalDocuments) * 100;
}

  // uploadDocumentAndStoreURL(file: File, index: number): Promise<string> {
  //   const doc = this.documents[index];
  //   doc.uploading = true; // start loader

  //   return new Promise((resolve, reject) => {
  //     this.imgUploadService.ImageMaster_ExternalUpload(file).subscribe({
  //       next: (res) => {
  //         const imgURL = res.fileURL;

  //         doc.uploading = false; // stop loader
  //         doc.uploaded = true;
  //         doc.fileName = file.name;
  //         const now = new Date();
  //         doc.uploadedTime =
  //           now.toLocaleDateString() + " " + now.toLocaleTimeString();
  //         doc.fileUrl = imgURL;
  //         this.updateProgress();
  //         this.isAllDocumentUploaded();
  //         resolve(imgURL);
  //       },
  //       error: (err) => {
  //         console.log(err);
  //         reject(err);
  //       },
  //     });
  //   });
  // }

  uploadDocumentAndStoreURL(file: File, index: number): Promise<string> {
  const doc = this.documents[index];
  doc.uploading = true;

  return new Promise((resolve, reject) => {
    this.imgUploadService.ImageMaster_ExternalUpload(file).subscribe({
      next: (res) => {
        const imgURL = res.fileURL;

        doc.uploading = false;
        doc.uploaded = true;
        doc.fileName = file.name;

        const now = new Date();
        doc.uploadedTime =
          now.toLocaleDateString() + " " + now.toLocaleTimeString();

        doc.fileUrl = imgURL;

        this.updateProgress();
        this.isAllDocumentUploaded();

        resolve(imgURL);
      },
      error: (err) => {
        console.log(err);
        doc.uploading = false;
        this.updateProgress();
        this.isAllDocumentUploaded();
        reject(err);
      },
    });
  });
}

  // async bulkUploadAllTheDocuments() {
  //   if (!this.sessionInfo) {
  //     alert("Session not exist.");
  //     this.refreshPage();
  //     return;
  //   } else {
  //     this.isUploading = true;

  //     const data: DocumentVerificationSessionReadByIdRequestDTO = {
  //       sessionId: this.sessionInfo.sessionId,
  //     };
  //     this.documentVerificationSessionServices
  //       .DocumentVerificationSession_ExternalReadById(data)
  //       .subscribe({
  //         next: (res) => {
  //           const allDocument = this.documents.filter((d) => d.fileUrl !== "");

  //           const docList: SocietyDocMasterCreateBulkObjectDTO[] =
  //             allDocument.map<SocietyDocMasterCreateBulkObjectDTO>((d) => {
  //               return {
  //                 masterType: d.category,
  //                 masterId: this.sessionInfo ? this.sessionInfo.masterId : 0,
  //                 docType: d.category,
  //                 docNo: d.name,
  //                 docDescription: d.subtext,
  //                 docPath: d.fileUrl,
  //               };
  //             });

  //           const payload: SocietyDocMasterCreateBulkRequestDTO = {
  //             docList: docList,
  //             actionUser: "Not Login",
  //           };

  //           this.societyDocMasterService
  //             .SocietyDocMaster_ExternalCreateBulk(payload)
  //             .subscribe({
  //               next: (res) => {
  //                 this.openSuccessModal();
  //                 this.deleteSession();
  //                 this.isUploading = false;
  //               },
  //               error: (err) => {
  //                 console.log(err);
  //                 this.isUploading = false;
  //               },
  //             });
  //           this.isDataLoading = false;
  //         },
  //         error: (err) => {
  //           console.log(err);
  //           this.refreshPage();
  //           this.isDataLoading = false;
  //         },
  //       });
  //   }
  // }

  async bulkUploadAllTheDocuments() {
  if (!this.sessionInfo) {
    alert("Session not exist.");
    this.refreshPage();
    return;
  }

  const allDocument = this.documents.filter((d) => d.fileUrl !== "");

  if (allDocument.length === 0) {
    alert("Please upload at least one document before submitting.");
    return;
  }

  this.isUploading = true;

  const data: DocumentVerificationSessionReadByIdRequestDTO = {
    sessionId: this.sessionInfo.sessionId,
  };

  this.documentVerificationSessionServices
    .DocumentVerificationSession_ExternalReadById(data)
    .subscribe({
      next: (res) => {
        if (!res || res.masterType !== "Society") {
          alert("Upload session is not valid.");
          this.isUploading = false;
          this.refreshPage();
          return;
        }

        const docList: SocietyDocMasterCreateBulkObjectDTO[] =
          allDocument.map<SocietyDocMasterCreateBulkObjectDTO>((d) => {
            return {
              masterType: d.category,
              masterId: this.sessionInfo ? this.sessionInfo.masterId : 0,
              docType: d.category,
              docNo: d.name,
              docDescription: d.subtext,
              docPath: d.fileUrl,
            };
          });

        const payload: SocietyDocMasterCreateBulkRequestDTO = {
          docList: docList,
          actionUser: "Not Login",
        };

        this.societyDocMasterService
          .SocietyDocMaster_ExternalCreateBulk(payload)
          .subscribe({
            next: (res) => {
              this.openSuccessModal();
              this.deleteSession();
              this.isUploading = false;
            },
            error: (err) => {
              console.log(err);
              this.isUploading = false;
            },
          });

        this.isDataLoading = false;
      },
      error: (err) => {
        console.log(err);
        this.isUploading = false;
        this.refreshPage();
        this.isDataLoading = false;
      },
    });
}

  deleteSession() {
    if (this.sessionInfo) {
      const payload: DocumentVerificationSessionDeleteRequestDTO = {
        sessionId: this.sessionInfo.sessionId,
        actionUser: "Not Login",
      };

      this.documentVerificationSessionServices
        .DocumentVerificationSession_ExternalDelete(payload)
        .subscribe({
          next: (res) => {},
          error: (err) => {
            console.log(err);
          },
        });
    }
  }

  modalEl: any;
  modalInstance: any;

  ngAfterViewInit(): void {
    this.modalEl = document.getElementById("successPopper");

    // Use Bootstrap JS available in window scope
    // Avoids TypeScript import errors completely
    // @ts-ignore
    this.modalInstance = new window.bootstrap.Modal(this.modalEl, {
      backdrop: "static",
      keyboard: false,
    });
  }

  openSuccessModal() {
    if (this.modalInstance) {
      this.modalInstance.show();
    }
  }

  refreshPage() {
    window.location.reload();
  }

  isDocumentUploadedPresent(docType: string = "") {
    return Object.keys(this.verificationDocuments).includes(docType);
  }

  // getDocumentsByMasterId(masterType: string, masterId: number) {
  //   const payload: SocietyDocMasterReadByMasterIdRequestDTO = {
  //     masterType,
  //     masterId,
  //   };

  //   this.societyDocMasterService
  //     .SocietyDocMaster_ExternalReadByMasterId(payload)
  //     .subscribe({
  //       next: (res) => {
  //         res.items.forEach((d) => {
  //           this.verificationDocuments[d.docNo] = d.docPath;
  //         });

  //         this.documents.map((d) => {
  //           d.isAlreadyUploaded = this.isDocumentUploadedPresent(d.name);
  //         });

  //         this.totalDocuments = this.documents.filter(
  //           (d) => !d.isAlreadyUploaded && d.fileUrl == ""
  //         ).length;

  //         console.log("documents", this.documents);
  //         console.log(
  //           "All the verifiation documents",
  //           this.verificationDocuments
  //         );
  //       },
  //       error: (err) => {
  //         console.log(err);
  //       },
  //     });
  // }

  getDocumentsByMasterId(masterType: string, masterId: number) {
  const payload: SocietyDocMasterReadByMasterIdRequestDTO = {
    masterType,
    masterId,
  };

  this.societyDocMasterService
    .SocietyDocMaster_ExternalReadByMasterId(payload)
    .subscribe({
      next: (res) => {
        this.verificationDocuments = {};

        res.items.forEach((d) => {
          this.verificationDocuments[d.docNo] = d.docPath;
        });

        this.documents.forEach((d) => {
          d.isAlreadyUploaded = this.isDocumentUploadedPresent(d.name);
        });

        this.totalDocuments = this.documents.filter(
          (d) => !d.isAlreadyUploaded
        ).length;

        this.updateProgress();
        this.isAllDocumentUploaded();
      },
      error: (err) => {
        console.log(err);
      },
    });
}
}
